export default __webpack_public_path__ + "static/media/4.1e1db5c0.png";